(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list-item.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list-item.js');
"use strict";


const ScoreItem = svs.components.marketplaceCompetition.routeResult.highscore.ScoreItem;
const _svs$components$marke = svs.components.marketplaceCompetition.services.constants.highscoreConstants,
  PositionDirection = _svs$components$marke.PositionDirection,
  HighscoreListType = _svs$components$marke.HighscoreListType;
const CompetitionDetails = svs.components.marketplaceCompetition.routeResult.details.CompetitionDetails;
const selectCompetitionDraws = svs.components.marketplaceCompetition.services.selectors.competitionSelectors.selectCompetitionDraws;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const Initials = svs.components.marketplaceShared.initials.Initials;
const _svs$components$marke2 = svs.components.marketplaceCompetition.services.hooks,
  useCompetitionType = _svs$components$marke2.useCompetitionType,
  useCompetitionBranding = _svs$components$marke2.useCompetitionBranding;
const HighScoreListItem = _ref => {
  var _useSelector$length, _useSelector;
  let competitionId = _ref.competitionId,
    el = _ref.el,
    type = _ref.type;
  const competitionType = useCompetitionType(competitionId);
  const competitionBranding = useCompetitionBranding(competitionType);
  let currentScore = 0;
  let direction = PositionDirection.Unmoved;
  if (el.draws.length > 0) {
    var _latestDraw$correctCo, _latestDraw$positionC;
    const latestDraw = el.draws[el.draws.length - 1];
    currentScore = (_latestDraw$correctCo = latestDraw === null || latestDraw === void 0 ? void 0 : latestDraw.correctCount) !== null && _latestDraw$correctCo !== void 0 ? _latestDraw$correctCo : 0;
    const positionChangeSinceLast = (_latestDraw$positionC = latestDraw === null || latestDraw === void 0 ? void 0 : latestDraw.positionChangeSinceLast) !== null && _latestDraw$positionC !== void 0 ? _latestDraw$positionC : 0;
    if (positionChangeSinceLast > 0) {
      direction = PositionDirection.Up;
    } else if (positionChangeSinceLast < 0) {
      direction = PositionDirection.Down;
    }
  }
  let name;
  let location;
  let Details;
  let isTeam = false;
  let InitialsForPlayer;
  const numberOfDraws = (_useSelector$length = (_useSelector = useSelector(state => selectCompetitionDraws(state, competitionId))) === null || _useSelector === void 0 ? void 0 : _useSelector.length) !== null && _useSelector$length !== void 0 ? _useSelector$length : 6;
  if (type === HighscoreListType.Team) {
    name = el.name;
    location = '';
    isTeam = true;
    Details = () => React.createElement(CompetitionDetails, {
      drawResults: el.draws,
      numberOfDraws: numberOfDraws,
      type: type
    });
  } else {
    InitialsForPlayer = () => React.createElement(Initials, {
      "aria-hidden": "true",
      className: "highscore-initials highscore-initials-".concat(competitionBranding),
      firstname: el.firstname,
      isAnonymous: el.isAnonymous,
      lastname: el.lastname
    });
    name = "".concat(el.firstname, " ").concat(el.lastname);
    location = el.location;
    Details = () => React.createElement(CompetitionDetails, {
      drawResults: el.draws,
      numberOfDraws: numberOfDraws,
      type: type
    });
  }
  return React.createElement(ScoreItem, {
    competitionBranding: competitionBranding,
    currentScore: currentScore,
    Details: Details,
    direction: direction,
    Initials: InitialsForPlayer,
    isTeam: isTeam,
    location: location,
    name: name,
    position: el.position,
    totalScore: el.totalCorrectCount
  });
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighScoreListItem', HighScoreListItem);

 })(window);